import { signal } from "@preact/signals-react";

export const bedsState = signal<unknown[]>([]);
